export enum StockManagementType {
	ARTICLE = 'articles',
	OPTION = 'options',
	ALL = '',
}
